module.exports = __webpack_public_path__ + "static/logo-75d50bd2eee06ba858ecae7955271ded.png";